import React, { useState, useEffect } from 'react'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useQuery, useMutation } from 'react-query'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";

import * as Yup from 'yup'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import { Formik, Form, Field, FieldArray } from 'formik';
function VerifyOTP(){
    const [initialValues, setInitialValues] = useState({
       
            email        : localStorage.getItem('email') || "",
            userOTP      : "",
       
    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("verifyotp",values)

      mutation.mutate( {email:values.email,otp : parseInt(values.userOTP)})
     
   
 }

 useEffect(() => {

    localStorage.getItem('email')
}, [])

 const mutation = useMutation((params) => Fetcher('patch', '/api/user/patch/verifypassword',params), {
    
    onSuccess(data) {
        if (data.data.errorCode === 0) {
            ToastInstance('Success', 'OTP Matched')
            //history.push('/viewauditplan/' + data.data.response.orgCode);
            window.location.href = '/resetpassword'
        } else {
            var msg = 'Please verify the OTP - ' + data.data.errorMsg;
            ToastInstance('Error', msg)
        }
    },
    onError(error) {
        console.log('Got error from backend', error)
        ToastInstance('Error', 'OTP Not Matched' + error)
    }
})



  

const  mutationgetResndOTP = useMutation((params) => Fetcher('patch', '/api/user/patch/generateotp' , params), {
    onSuccess(data) {
        if (data.data.errorCode === 0) {
            ToastInstance('Success', 'OTP has been Resend to your Email Id')
            
        } else {
            var msg = 'OTP - ' + data.data.errorMsg;
            ToastInstance('Error', msg)
        }
    },
    onError(error) {
        console.log('Got error from backend', error)
        ToastInstance('Error', 'OTP ' + error)
    }

})
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            //validationSchema={validationSchema}
           onSubmit={onSubmit}
        >
            {
                formik => <Form>     
                <div className="hold-transition loginpage">
                     <div className="login-box">
                            <div className="row text-center">
                                <h4>Audit Application </h4>
                            </div>
                            <br></br>
                    <div className="login-box-body">
                        <p className="login-box-msg">
                                Verify OTP <br />
                                <span style={{ fontSize: 12,  marginTop: -15 }}>OTP has been send on the Register Email Id</span>
                        </p>

                        <div className="form-group has-feedback">
                            <FormikControl control='input' type="text" name='email'   />

                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                        
                        </div>
                        <br></br>
                        <div className="form-group has-feedback">
                            {/* <input type="text" className="form-control login-textbox" name="userOTP" className="form-control" placeholder="OTP" onChange={this.handleChange("userOTP")} /> */}
                            <FormikControl control='input' type="text" name='userOTP' placeholder='Enter OTP ' />

                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                           
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <span style={{cursor:"pointer", fontSize:"15px", color:"blue", textDecoration: "underline",}} onClick={e => { mutationgetResndOTP.mutate({email:localStorage.getItem('email') }); }}>Resend OTP</span><br />
                            </div>
                        </div> 
                        <div classname="row" style={{marginLeft:"55%"}}>
                          
                                <button type="submit" className="btn btn-primary btn-block btn-flat" >Verify OTP</button>
                           
                        </div>
                    </div>
                </div>
            </div>    
                </Form>
   
   }
   </Formik>
   )

}
export default VerifyOTP